import React from 'react';
// utils
import { Translations, convertStringToArray, convertStringToArrayForOption, checkBoolean } from '../../../../utils';
// children
import NavListAccordion, { NavListAccordionWrapper } from '../../../common/NavListAccordion/NavListAccordion';

class CashFlowForecasting extends React.Component {

  translateWord = (word) => {
    var currentWord = Translations(word, this.props.lang.currentLang.lang, this.props.lang.translatedData)
    var convertedArray = convertStringToArray(currentWord);
    return convertedArray;
  }

  render() {
    const { cffProduct, pageJson } = this.props;
    /*=================================cffProduct start================================================*/

    return (
      <div className="gdoc-preview-request-content">
        <span>
          {Translations(pageJson.dynamic_accordion_list_cashflowForecasting.title, this.props.lang.currentLang.lang, this.props.lang.translatedData)}
        </span>
        <NavListAccordionWrapper>
          {cffProduct !== undefined && cffProduct.length > 0 ? cffProduct.map((product, key) => {
            const tabTitleHtml = (
              <div>
                <div className="Title">
                  {product.productType !== undefined && product.productType.name !== undefined ? product.productType.name + ", " : ""}
                  {product.country !== undefined ? product.country.name + ", " : ""}
                  {product.currency !== undefined ? product.currency.name : ""}
                </div>
                <div className="SubTitle">
                  {product.cffAgent !== undefined ? product.cffAgent.name + " " : ""}
                  {product.country !== undefined ? product.country.name + " " : ""}
                  {product.productType !== undefined ? product.productType.name : "''"}
                </div>
              </div>);

            /*=================================TabPanelContentBasicDetails start================*/
            const TabPanelContentBasicDetails = (
              <div className="basic-details-container">
                <div className="basic-detail-heading">{this.translateWord(pageJson.dynamic_accordion_list_cashflowForecasting.fieldLabels)[0]}</div>
                <div className="basic-detail-content">
                  <dl className="dl-horizontal">
                    <dt>{this.translateWord(pageJson.dynamic_accordion_list_cashflowForecasting.fieldLabels)[1]}</dt>
                    <dd>
                      <b>{product.cffAgent !== undefined && product.cffAgent.name !== undefined ? product.cffAgent.name : ""}</b>
                    </dd>
                    <dt>{this.translateWord(pageJson.dynamic_accordion_list_cashflowForecasting.fieldLabels)[2]}</dt>
                    <dd><b>{product.country !== undefined && product.country.name !== undefined ? product.country.name : ""}</b>
                    </dd>
                  </dl>
                </div>
              </div>
            );
            /*=================================TabPanelContentBasicDetails end==============================*/

            /*=================================EchannelsReports start================*/
            const TabPanelContentEchannelsReports = (
              <div className="basic-details-container">
                <div className="basic-detail-heading">{this.translateWord(pageJson.dynamic_accordion_list_cashflowForecasting.fieldLabels)[3]}
                </div>
                <div className="basic-detail-content">
                  <dl className="dl-horizontal">
                    <dt>{this.translateWord(pageJson.dynamic_accordion_list_cashflowForecasting.fieldLabels)[4]}</dt>
                    <dd>
                      <b>{(product.reportToEchannel) !== undefined ? product.reportToEchannel === true ? "Yes" : "No" : ""}</b>
                    </dd>
                    <dt>{this.translateWord(this.props.pageJson.dynamic_accordion_list_cashflowForecasting.fieldLabels)[5]}
                    </dt>
                    {checkBoolean(product.reportToEchannel) && Array.isArray(product.eChannelReporting) && product.eChannelReporting.length ?
                      <dd>
                        <b>HSBCnet, {product.country && product.country.name}</b>
                        <p>{product.cffAgent && product.cffAgent.name}</p>
                      </dd>
                      : <dd></dd>}
                  </dl>
                </div>
              </div>
            );
            /*=================================EchannelsReports end==============================*/
            return (
              <NavListAccordion navAccHeading={tabTitleHtml} key={key}>
                <div className="basic-details-section">
                  {TabPanelContentBasicDetails}
                  <span className="basic-details-section-bar"></span>
                  {TabPanelContentEchannelsReports}
                </div>
              </NavListAccordion>
            )
          }) : ""}
        </NavListAccordionWrapper>
      </div>
    )
  }
  /*=================================cffProduct end========================================================================*/
}
export default CashFlowForecasting;



// WEBPACK FOOTER //
// ./src/components/CaseBody/PreviewRequest/Child/Cash Flow Forecasting.js